import { MentionsType } from '@shared/components/Editor/util/Mentions.util'

import { GroupQueries } from '@/graphql/queries/group.queries'

import { useGraphql } from '../useGraphql'

export const useMissionControlGroups = () => {
  const { data } = useGraphql<GroupQueries.GET_GROUPS.Response>(
    GroupQueries.QUERY_KEY,
    GroupQueries.getMissionControlGroups(),
    {
      limit: 200,
    },
  )

  const groups: MentionsType[] = data?.groups
    ? data?.groups.map((group) => {
        return { label: group.name + '', value: group.id }
      })
    : []
  return { groups }
}
